import React from "react";
import styles from "./FreeOrderSuccess.module.scss";
import CalendarIcon from "../../../../assets/img/calendar_green.png";
const days = [
  "niedziela",
  "poniedziałek",
  "wtorek",
  "środa",
  "czwartek",
  "piątek",
  "sobota",
];
const months = [
  "styczeń",
  "luty",
  "marzec",
  "kwiecień",
  "maj",
  "czerwiec",
  "lipiec",
  "sierpień",
  "wrzesień",
  "październik",
  "listopad",
  "grudzień",
];

class FreeOrderSuccess extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }

  render() {
    const { time } = this.props;

    return (
      <div className={styles.OrderConsultation}>
        <div>
          <div className={styles.ModalContent}>
            <div className={styles.thanksInfo}>
              <p>Dziękujemy za zarezerwowanie wybranego terminu.</p>

              <div className={styles.info}>
                <img src={CalendarIcon} alt="calendar" />
                <div>
                  {days[time.start.getDay()]}, {time.start.getDate()}{" "}
                  {months[time.start.getMonth()]}, {time.start.getHours()}:
                  {time.start.getMinutes() < 10
                    ? "0" + time.start.getMinutes()
                    : time.start.getMinutes()}
                  <br />
                </div>
              </div>

              <p>
                Wkrótce otrzymasz dalsze informacje o zbliżającej się
                wideokonsultacji.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FreeOrderSuccess.defaultProps = {};

export default FreeOrderSuccess;
